<template>
  <!-- タブボタン部分 -->
  <ul class="nav nav-tabs">
    <li class="nav-item" v-if="loginUserInfo.auth_order_nomal">
      <a
        @click.prevent="
          submitAsteria(
            'Order',
            'loadHTML_forOrder',
            {},
            '/tab/order-simple',
            '/order/#/tab/order-simple'
          )
        "
        class="nav-link"
        href="#"
        >簡易発注</a
      >
    </li>
    <li
      class="nav-item"
      v-if="
        loginUserInfo.auth_order_nomal &&
          order_screen_ptn_di != 'A03' &&
          order_screen_ptn_di != 'A04' &&
          order_screen_ptn_di != 'A05' &&
          order_screen_ptn_di != 'A06'
      "
    >
      <a
        @click.prevent="
          submitAsteria(
            'Order',
            'loadHTML_forOrder',
            {},
            '/tab/order-hand',
            '/order/#/tab/order-hand'
          )
        "
        class="nav-link"
        href="#"
        >手書き発注</a
      >
    </li>
    <li
      class="nav-item"
      v-if="
        loginUserInfo.auth_order_nomal &&
          loginUserInfo.bulkorder_fg &&
          order_screen_ptn_di != 'A03' &&
          order_screen_ptn_di != 'A04' &&
          order_screen_ptn_di != 'A05' &&
          order_screen_ptn_di != 'A06'
      "
    >
      <a
        @click.prevent="
          submitAsteria(
            'Order',
            'loadHTML_forOrder',
            {},
            '/tab/order-bulk',
            '/order/#/tab/order-bulk'
          )
        "
        class="nav-link"
        href="#"
        >まとめ発注</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_order_file">
      <router-link
        :to="{ name: 'order-file' }"
        class="nav-link"
        active-class="active"
        >ファイル発注</router-link
      >
    </li>
  </ul>
</template>

<script>
import { store as loginUserStore } from "../../store/LoginUser";
import { store as FileOrderStore } from "../../store/FileOrder";

export default {
  computed: {
    loginUserInfo() {
      return loginUserStore.info;
    },
    order_screen_ptn_di: {
      get() {
        return FileOrderStore.order_screen_ptn_di;
      }
    }
  }
};
</script>
